export default "__VITE_ASSET__C2Qk8Z5a__"